import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from 'react-router-dom/Link';
import { toUpper } from 'lodash';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import {
  NavbarToggler,
  Collapse,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { setLang } from '../services/Application/actions';
import logo from '../assets/oakhouse-logo-square.png';

const Nav = styled.nav`
  padding-top: 0px !important;
  padding-bottom: 0px !important;
`;

const Logo = styled.img`
  height: 50px;
  width: auto;
`;

const Items = styled.ul`
  @media (min-width: 768px) {
    width: 100% !important;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
`;

class Navbar extends Component {
  static propTypes = {
    lang: PropTypes.string.isRequired,
    setLang: PropTypes.func.isRequired,
  }

  static contextTypes = {
    router: PropTypes.shape({
      route: PropTypes.shape({
        location: PropTypes.shape({
          pathname: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  }

  state = {
    isOpen: false,
  }

  toggle = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  isActive = (path) => {
    const { router: { route: { location: { pathname } } } } = this.context;
    if (path === pathname) {
      return true;
    }
    return false;
  }

  getCurrentLang = (lang) => {
    switch (toUpper(lang)) {
      case 'EN': return (<FormattedMessage id="Lang.JA" />);
      case 'JA': return (<FormattedMessage id="Lang.EN" />);
      default: return (<FormattedMessage id="Lang.EN" />);
    }
  }

  onLangChange = (lang) => {
    this.props.setLang(lang);
  }

  render() {
    const { isOpen } = this.state;
    const { lang } = this.props;

    return (
      <header>
        <Nav className="navbar navbar-expand-md navbar-dark fixed-top bg-white shadow">
          <div className="container">
            <Link
              to="/"
              className="navbar-brand"
            >
              <Logo
                src={logo}
                alt="oakhouse logo"
              />
            </Link>
            <NavbarToggler
              className="text-primary"
              style={{ borderColor: '#fa5a56' }}
              onClick={this.toggle}
            >
              <FontAwesomeIcon icon="bars" />
            </NavbarToggler>
            <Collapse isOpen={isOpen} navbar>
              <Items className="navbar-nav">
                <li
                  className={classNames('nav-item', {
                    active: this.isActive('/'),
                  })}
                >
                  <Link
                    to="/"
                    className="nav-link"
                  >
                    <FormattedMessage id="Navbar.Home" />
                  </Link>
                </li>
                <li
                  className={classNames('nav-item', {
                    active: this.isActive('/'),
                  })}
                >
                  <Link
                    to="/workshop"
                    className="nav-link"
                  >
                    <FormattedMessage id="Navbar.Workshop" />
                  </Link>
                </li>
                <li
                  className={classNames('nav-item', {
                    active: this.isActive('/'),
                  })}
                >
                  <Link
                    to="/exhibition"
                    className="nav-link"
                  >
                    <FormattedMessage id="Navbar.Exhibition" />
                  </Link>
                </li>
                <li
                  className={classNames('nav-item', {
                    active: this.isActive('/'),
                  })}
                >
                  <Link
                    to="/flea-market"
                    className="nav-link"
                  >
                    <FormattedMessage id="Navbar.FleaMarket" />
                  </Link>
                </li>
                <li
                  className={classNames('nav-item', {
                    active: this.isActive('/'),
                  })}
                >
                  <Link
                    to="/access"
                    className="nav-link"
                  >
                    <FormattedMessage id="Navbar.Access" />
                  </Link>
                </li>
                <li
                  className={classNames('nav-item', {
                    active: this.isActive('/'),
                  })}
                >
                  <Link
                    to="/contact-us"
                    className="nav-link"
                  >
                    <FormattedMessage id="Navbar.ContactUs" />
                  </Link>
                </li>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    {this.getCurrentLang(lang)}
                  </DropdownToggle>
                  <DropdownMenu
                    style={{
                      borderRadius: 0,
                      marginBottom: 15,
                      borderColor: '#fa5a56',
                    }}
                    right
                  >
                    <DropdownItem
                      onClick={() => this.onLangChange('EN')}
                    >
                      <FormattedMessage id="Lang.EN" />
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => this.onLangChange('JA')}
                    >
                      <FormattedMessage id="Lang.JA" />
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Items>
            </Collapse>
          </div>
        </Nav>
      </header>
    );
  }
}

const mapStateToProps = state => ({
  lang: state.Application.lang,
});

const mapDispatchToProps = {
  setLang,
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
